
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditNationalEventForm } from '@/services/Calendar/NationalEvents/forms/EditNationalEventForm';
import { NationalEventsInterface } from '@/services/Calendar/NationalEvents/Interfaces';
import NationalEventsRepository from '@/services/Calendar/NationalEvents';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
  },
  inject: [
    'nationalEventsRepository',
  ],
})
export default class EditRecurringEvent extends Vue {
  private readonly nationalEventsRepository!: NationalEventsRepository;

  private loading: boolean = true;
  private dateMenu: boolean = false;
  private movableMethods: Array<{ method: string, name: string }> = [];

  private recurringEvent: Partial<NationalEventsInterface> = {};
  private form: WPXFormValue<EditNationalEventForm> = new WPXFormValue(EditNationalEventForm);

  private async created(): Promise<void> {
    if (!this.$route.params.eventId) {
      await this.$router.push({ name: 'calendar_manage_events',  });
      this.$notifications.error('National event ID not provided.');

      return;
    }

    const methods = await this.nationalEventsRepository.getAllMovableMethods();
    this.movableMethods = methods.map((method) => {
      return { method, name: method.replace('movable', 'Calculate').replace(/([A-Z])/g, ' $1').trim() }
    });

    try {
      this.recurringEvent = await this.nationalEventsRepository
        .getNationalEvent(Number(this.$route.params.eventId));
      this.form.data.name = String(this.recurringEvent.name);
      this.form.data.localName = String(this.recurringEvent.localName);
      this.form.data.isFixedDate = Boolean(this.recurringEvent.isFixedDate);

      if (this.recurringEvent.date) {
        this.form.data.date = new Date(this.recurringEvent.date).toISOString().substr(0, 10);
      }

      if (this.recurringEvent.movableMethod) {
        this.form.data.movableMethod = String(this.recurringEvent.movableMethod);
      }
    } catch (e) {
      console.error(e);
    }

    this.loading = false;
  }

  private async edit(): Promise<void> {
    try {
      await this.nationalEventsRepository.updateNationalEvent({
        id: Number(this.$route.params.eventId),
        name: this.form.data.name,
        localName: this.form.data.localName,
        isFixedDate: this.form.data.isFixedDate,
        date: new Date(this.form.data.date),
        movableMethod: this.form.data.movableMethod,
      });

      this.$successDialog.show(`Recurring event '${this.form.data.name}' has been edited.`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }
}
